export default {
    imagesResult: [],
    contentCategory: [],
    contentByCategoryRef: [],
    contentListByCategoryRef: [],
    contentListByCategoryFAQ: [],
    contentListByCategoryComments: [],
    contentListByCategoryArticles: [],
}